// extracted by mini-css-extract-plugin
export var black = "_l-6";
export var brand = "_l-1";
export var ddefault = "_l-0";
export var error = "_l-3";
export var gray = "_l-2";
export var highContrast = "_l-8";
export var outline = "_l-7";
export var success = "_l-5";
export var warning = "_l-4";